// Sharing belongs to the inventory/share service, not to an exported activity.
// Re-importing or saving old content must not restore an obsolete sharing flag.
export function preserveInventorySharingMetadata(document = {}, inventoryEntry = {}) {
	const result = { ...document };
	delete result.share;
	delete result.hasShares;
	if (inventoryEntry.share) {
		result.share = inventoryEntry.share;
	}
	if (typeof inventoryEntry.hasShares === "boolean") {
		result.hasShares = inventoryEntry.hasShares;
	}
	return result;
}

export function hasActivityShareRecipients(share = {}) {
	return [share.groups, share.members].some((recipients) => {
		if (Array.isArray(recipients)) {
			return recipients.length > 0;
		}
		return typeof recipients === "string" && recipients.split(",").some((id) => id.trim() !== "");
	});
}
